import { MatrixCalculationType, MatrixContractSettlement, MatrixStripType, MatrixTerm } from '../../../../Generated/Mark-It-View-Api';

export interface MatrixReportConfiguration {
  defaults?: {
    weighted?: boolean;
    innerRange?: number;
    outerRange?: number;
    innerWeight?: number;
    outerWeight?: number;
    yearsBack?: number;
    terms?: MatrixTerm[];
  };
}

export const MatrixTermLabels: Record<MatrixTerm, string> = {
  [MatrixTerm.Annual]: 'Annual',
  [MatrixTerm.Summer]: 'Summer',
  [MatrixTerm.Winter]: 'Winter',
  [MatrixTerm.FirstQuarter]: 'Q1',
  [MatrixTerm.SecondQuarter]: 'Q2',
  [MatrixTerm.ThirdQuarter]: 'Q3',
  [MatrixTerm.FourthQuarter]: 'Q4',
  [MatrixTerm.JanuaryFebruary]: 'January-February',
  [MatrixTerm.MarchApril]: 'March-April',
  [MatrixTerm.JulyAugust]: 'July-August',
  [MatrixTerm.OctoberDecember]: 'October-December',
  [MatrixTerm.Custom]: 'Custom',
};

export const MatrixStripTypeLabels: Record<MatrixStripType, string> = {
  [MatrixStripType.FirstContractMonth]: '1st Contract Month (NG Settlement)',
  [MatrixStripType.SecondContractMonth]: '2nd Contract Month',
  [MatrixStripType.Strip]: '12 Month Strip',
  [MatrixStripType.ContractPeriod]: 'Forward Contract',
  [MatrixStripType.RollingMonth]: '1st Contract Month',
};

export const MatrixContractSettlementLabels: Record<MatrixContractSettlement, string> = {
  [MatrixContractSettlement.ExpirationDate]: 'Expiration Date',
  [MatrixContractSettlement.LastDayOfTheMonth]: 'Last Day of Month',
};

export const MatrixCalculationTypeLabels: Record<MatrixCalculationType, string> = {
  [MatrixCalculationType.Monthly]: 'Monthly',
  [MatrixCalculationType.Expiration]: 'Expiration',
};

export enum PriceOverlayType {
  None = 'None',
  Daily = 'Daily',
  LastSettlement = 'LastSettlement',
}

export const PriceOverlayTypeLabels: Record<PriceOverlayType, string> = {
  [PriceOverlayType.None]: 'None',
  [PriceOverlayType.Daily]: 'Daily',
  [PriceOverlayType.LastSettlement]: 'Last Settlement',
};
